module.exports = "<p>\n  company-rate-table works!\n</p>\n"